<template>
<v-container fluid>
     <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert=false" :info="info" />
<v-form ref="form" v-model="valid">
    <v-row>
        <v-col>
          <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
            <v-select
    v-if="!loading"
          v-model="form.valueParam"
          :items="valueParamOptions"       
          :label="$store.getters.getTextMap().value"
         :rules="objectRules"
         required
          item-text="label"
          item-value="value"
          clearable
        ></v-select>
        </v-col>
        <v-col>
          <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
            <v-select
    v-if="!loading"
          v-model="form.by"
          :items="byOptions"       
          :label="$store.getters.getTextMap().by"
         :rules="objectRules"
         required
          item-text="label"
          item-value="value"
          clearable
        ></v-select>
        </v-col>
        <v-col>
          <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
        <v-checkbox
          v-if="!loading"
      v-model="dateRange"
      :label="$store.getters.getTextMap().date_range"
    ></v-checkbox>
    </v-col>
        <v-col align-self="center">
          <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
            <v-btn
          v-if="!loading"
          :color="$store.getters.getColorPalette().submitbtnColor"
            outlined
            @click="onSubmit"
          >
          {{$store.getters.getTextMap().generate_trend}}

          </v-btn>
        </v-col>
    </v-row>
   <v-row>
        <v-col v-if="dateRange">
            <v-select
    v-if="!loading"
          v-model="form.dateParam"
          :items="dateParamOptions"       
          :label="$store.getters.getTextMap().value"
         :rules="objectRules"
         required
          item-text="label"
          item-value="value"
          clearable
        ></v-select>
        </v-col>
        <v-col v-if="dateRange">
        <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
                <v-menu
        v-if="!loading"
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="form.from_date"
            :label="$store.getters.getTextMap().from_date"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            :rules="objectRules"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.from_date"
          @input="menu1 = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col v-if="dateRange">
        <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
                <v-menu
        v-if="!loading"
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="form.to_date"
            :label="$store.getters.getTextMap().to_date"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            :rules="objectRules"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.to_date"
          @input="menu2 = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    </v-row>
    
    <v-row v-if="graphData && graphData.length>0">
        <v-col align-self="center">
            <v-simple-table  height="350px">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            <strong>{{report.by}}</strong>
          </th>
          <th class="text-right">
            <strong>{{report.valueParam}}</strong>
          </th>
          
         
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in graphData"
          :key="item[report.by]"
        >
          <td>{{ item[report.by] }}</td>
          <td class="text-right">{{item[report.valueParam]}}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
        </v-col>
        <v-col align-self="center">
            <v-card class="pa-2">
            <BarGraphByLabel :graphData="graphData" :label="report.valueParam" :dataKey="report.valueParam" :labelKey="report.by"  />
            </v-card>
        </v-col>
    </v-row>
    <v-row v-if="graphData && graphData.length>0">
        <v-col>
            
        </v-col>
    </v-row>

</v-form>
</v-container>
</template>

<script>
import InfoAlert from '@/components/InfoAlert'
import BarGraphByLabel from '@/components/graphs/BarGraphByLabel'
import axios from 'axios'
export default {
    name:'DataGroupingPanel',
    components:{
        InfoAlert,
        BarGraphByLabel
    },
    mounted(){},
    data(){
        return {
            valid:false,
            loading:false,
            showDismissibleAlert:false,
            info:'',
            graphData:[],
            dateRange:false,
            menu1:null,
            menu2:null,
            form:{
                by:'board_name'
            },
            report:{},
            valueParamOptions:[
                //{label:'Billed Unit',value:'billed_unit'},
                {label:'Total Unit',value:'total_unit'},
                {label:'Meter Consumption Unit (KWH)',value:'meter_consumption_unit_kwh'},
                {label:'Bill Amount',value:'bill_amount'},
            ],
            byOptions:[
                {label:'Regions',value:'region'},
                {label:'Board Name',value:'board_name'},
            ],
            dateParamOptions:[
                //{label:'Billed Unit',value:'billed_unit'},
                {label:'Bill Due Date',value:'bill_due_date'},
                {label:'Bill Issue Date',value:'bill_issue_date'},
                {label:'Bill Receive Date',value:'bill_receive_date'},
            ],
            objectRules:[
                (v)=>!!v || 'required'
            ]
        }
    },
    methods:{
        onSubmit(){
            this.$refs.form.validate()
            if(this.valid){

                this.loading=true
                //let fromTimeStamp=this.fromTimeStamp
                //let toTimeStamp=this.toTimeStamp
                let payload={
                    by:this.form.by,
                    valueParam:this.form.valueParam,
                    }
                let endpoint='dataQuery'
                //console.log(fromTimeStamp)
                if(this.dateRange){
                    payload['to_date']=this.form.to_date
                    payload['from_date']=this.form.from_date
                    payload['dateParam']=this.form.dateParam
                }
                axios.post(this.$store.state.api+endpoint,payload,{headers: {
                Authorization: 'Bearer '+ this.$store.state.jwt
                }})
                .then(response=>{
                //console.log("report data received")
                //console.log(response.data)
                if(response.data.status==='success'){
                    this.report=Object.assign({},this.form)
                    this.graphData=response.data.data
                }else{
                    this.info = response.data.msg;
                //this.info = d;
                        this.showDismissibleAlert = true;
                //console.log(response.data.msg)
                //this.loading=false
                }
                this.loading=false
                }).catch(err=>{
                    this.showDismissibleAlert=true
                    this.info=err
                    this.loading=false
                })
            }
        },
    }
}
</script>